import React from 'react';
import SEO from '../../../Components/SEO';
import Breadcrumb from '../../../Components/Breadcrumb';
import { ActivityLayout } from '../../../Components/activity-layout';
import ActivityFilter from '../../../Shared/activityFilter';
import grammarData from './grammar-exercises-data';

const grammar = '/Images/4people2.webp';

const Grammarexercises = () => {
  return (
    <ActivityLayout
      title="Grammar Exercises"
      eyebrow="Grammar"
      image={grammar}
      intro="Here is a collection of grammar exercises to do. The exercises are divided by exam level, from beginner to advanced. Each level contains a range of grammar points. Keep checking back as I am always adding new exercises."
    >
      <SEO
        title="Free English Grammar Lesson Plans & Activities for ESL Teachers"
        description="Ready-to-use grammar lesson plans for online ESL teachers. Clear explanations, practice activities, and exercises organized by CEFR level and grammar point. Perfect for 1-to-1 or group classes."
        name="English Exam Exercises"
        type="article"
      />
      <Breadcrumb />
      <ActivityFilter
        data={grammarData}
        getLink={(item) => item.links?.[0]?.to || `/grammar-exercises/${item.id}`}
        ctaLabel="Start Exercise"
        resultsLabel="exercises"
        itemsPerPage={6}
      />
    </ActivityLayout>
  );
};

export default Grammarexercises;